/* eslint-disable import/prefer-default-export */
function ConversationScroll() {
  const conversation = $('#conversation');
  const messagesList = conversation.find('.messages-list');
  const height = messagesList[0].scrollHeight;
  messagesList.scrollTop(height);
}

export function ConversationReturnBack(ConversationId, Name) {
  $(document).ready(() => {
    ConversationScroll();
    const conversations = $(`.conversations-list-${ConversationId}`);
    if ($(window).width() < 768) {
      if (conversations.length > 0) {
        $('#conversations-list').addClass('chat-none');
        $('#conversation').addClass('chat-block');
        $('#chat-return-back').addClass('chat-none');
        $('.header-statistics.position-relative').html(Name);
      }

      if ($('#conversations-list').first().hasClass('chat-none')) {
        $('.chat-return-back').removeClass('chat-none');
        $('.header-statistics.position-relative').html(Name);
      }
    }

    conversations.click(() => {
      $('html, body').animate({
        scrollTop: $('.header-statistics.position-relative').offset().top - 450,
      });
    });
  });
}




// WEBPACK FOOTER //
// ./app/webpacker/src/js/conversation_return_back.js